module.exports = __webpack_public_path__ + "img/home-bg.ed64ad00.jpg";